import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { UNIT_TEXT } from "../DailyExpense/constants";

export interface Crumb {
  key: string;
  label: string;
  /** null = the level on screen (not a link). */
  onSelect: (() => void) | null;
}

interface ReportHeadingProps {
  crumbs: Crumb[];
  title: string;
  subtitle: string;
}

/** ทุกสาขา › สาขา › สาย, then the report's title and its days. */
export default function ReportHeading({ crumbs, title, subtitle }: Readonly<ReportHeadingProps>) {
  return (
    <Stack gap={0.5}>
      <Breadcrumbs aria-label="ระดับรายงาน">
        {crumbs.map((crumb) =>
          crumb.onSelect ? (
            <Link key={crumb.key} component="button" variant="body2" onClick={crumb.onSelect}>
              {crumb.label}
            </Link>
          ) : (
            <Typography key={crumb.key} variant="body2" fontWeight={600} color="text.primary">
              {crumb.label}
            </Typography>
          ),
        )}
      </Breadcrumbs>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-end" gap={2}>
        <Stack>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        </Stack>
        <Typography variant="caption" color="text.secondary">
          {UNIT_TEXT}
        </Typography>
      </Stack>
    </Stack>
  );
}
